import { eventBus } from '../../../main'
export default {
    name: 'appHeader',    
    created() { 
        window.scrollTo(0, 0);
        this.CheckLoginStatus();
        eventBus.$on('Logo', (data) => {
            this.IsLogoChanged = data.IsLogoChanged;
            this.Logo = data.Logo;
        })
    },
    data() {
        return {      
            loginDetails: null,
            active: 1,
            menuFlag: [30],
            IsLogoChanged: false,
            Logo: null
        };
    },
  
    methods: {
        showNotification(){
            this.$notify({
                title: 'تنبيه',
                message: 'جاري العمل علي نظام التعميم الالكتروني , سيتم اطلاقه قريبا',
                duration:6000,
                type: 'warning'
              });
        },
        Logout() {
            window.location.href = "/Login";
        },

        href(url, id) {
            this.$router.push(url);
            for (var i = 0; i < 30; i++) {
                if (i == id) {
                    this.$set(this.menuFlag, id, 'active');
                } else {
                    this.$set(this.menuFlag, i, '');
                }
            }
        },

        CheckLoginStatus() {
            try {
                this.loginDetails = JSON.parse(localStorage.getItem('currentUser-client'));
                if (this.loginDetails == null) {
                    window.location.href = '/Login';
                }
            } catch (error) {
                window.location.href = '/Login';
            }
        },

        OpenMenuByToggle() {
            var root = document.getElementsByTagName("body")[0]; // '0' to assign the first (and only `HTML` tag)
            if (root.getAttribute("class") == "rtl sidebar-mini rtl-active") {
                root.setAttribute("class", "rtl rtl-active");
            } else {
                root.setAttribute("class", "rtl sidebar-mini rtl-active");
            }
        },


    }    
}
